import { SubscriptionPlan } from "../pages/SubscriptionPage/SubscriptionPlan";

export const FeatureAccess = {
  flashSalePage: [
    SubscriptionPlan.LegacyBuilder,
    SubscriptionPlan.LegacyGrower,
    SubscriptionPlan.LegacyScaler,
    SubscriptionPlan.Professional,
    SubscriptionPlan.Elite,
    SubscriptionPlan.Unlimited
  ],
  saleBadges: [
    SubscriptionPlan.LegacyBuilder,
    SubscriptionPlan.LegacyGrower,
    SubscriptionPlan.LegacyScaler,
    SubscriptionPlan.Lite,
    SubscriptionPlan.Professional,
    SubscriptionPlan.Elite,
    SubscriptionPlan.Unlimited
  ],
  differentDiscounts: [
    SubscriptionPlan.LegacyBuilder,
    SubscriptionPlan.LegacyGrower,
    SubscriptionPlan.LegacyScaler,
    SubscriptionPlan.Professional,
    SubscriptionPlan.Elite,
    SubscriptionPlan.Unlimited
  ],
  excludeProducts: [
    SubscriptionPlan.LegacyBuilder,
    SubscriptionPlan.LegacyGrower,
    SubscriptionPlan.LegacyScaler,
    SubscriptionPlan.Lite,
    SubscriptionPlan.Professional,
    SubscriptionPlan.Elite,
    SubscriptionPlan.Unlimited
  ],
  excludeCollections: [
    SubscriptionPlan.LegacyBuilder,
    SubscriptionPlan.LegacyGrower,
    SubscriptionPlan.LegacyScaler,
    SubscriptionPlan.Lite,
    SubscriptionPlan.Professional,
    SubscriptionPlan.Elite,
    SubscriptionPlan.Unlimited
  ],
  autoTagProducts: [
    SubscriptionPlan.LegacyBuilder,
    SubscriptionPlan.LegacyGrower,
    SubscriptionPlan.LegacyScaler,
    SubscriptionPlan.Professional,
    SubscriptionPlan.Elite,
    SubscriptionPlan.Unlimited
  ],
  advancedAnnouncement: [
    SubscriptionPlan.LegacyBuilder,
    SubscriptionPlan.LegacyGrower,
    SubscriptionPlan.LegacyScaler,
    SubscriptionPlan.Lite,
    SubscriptionPlan.Professional,
    SubscriptionPlan.Elite,
    SubscriptionPlan.Unlimited
  ],
  heroBanner: [
    SubscriptionPlan.LegacyBuilder,
    SubscriptionPlan.LegacyGrower,
    SubscriptionPlan.LegacyScaler,
    SubscriptionPlan.Professional,
    SubscriptionPlan.Elite,
    SubscriptionPlan.Unlimited
  ],
  // Stores that used it before it was gated keep it through a feature grant (productessentials/backend#54).
  blockDiscountCodes: [
    SubscriptionPlan.LegacyScaler,
    SubscriptionPlan.Elite,
    SubscriptionPlan.Unlimited
  ],
  // Add more features and their corresponding plans here
};

// The plan includes the feature, or the store has a feature grant for it (SubscriptionMeta.FeatureGrants).
export function hasAccess(feature, currentPlan, grants) {
  return !!FeatureAccess[feature]?.includes(currentPlan) || !!grants?.includes(feature);
}

const FeaturePrettyNames = {
  flashSalePage: "Flash Sale Page",
  saleBadges: "Sale Badges",
  differentDiscounts: "Different Discounts",
  excludeProducts: "Exclude Products",
  excludeCollections: "Exclude Collections",
  autoTagProducts: "Auto-Tag Products",
  advancedAnnouncement: "Advanced Announcement",
  heroBanner: "Hero Banner",
  blockDiscountCodes: "Block Discount Codes",
  // Add more feature pretty names here
};

export function getFeaturePrettyName(feature) {
  return FeaturePrettyNames[feature] || feature;
}
